module.exports = __webpack_public_path__ + "assets/img/03-m.f02bfdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/03-m.jpg
// module id = aQqe
// module chunks = 0